import { TraceChart } from './trace-chart';
import type { ZipkinTraceSpan, SpanRenderer, SpanData } from './types';

export type { ZipkinTraceSpan, SpanData };

export interface ZipkinTraceChartProps<T = any> {
  spans: ZipkinTraceSpan<T>[];
  className?: string;
  height?: number;
  showTimeline?: boolean;
  showDuration?: boolean;
  showSidebar?: boolean;
  autoScroll?: boolean;
  renderSpan?: SpanRenderer<T>;
  onSpanClick?: (spanId: string) => void;
}

export const ZipkinTraceChart = <T = any,>({
  spans,
  className,
  height = 400,
  showTimeline = true,
  showDuration = true,
  showSidebar = true,
  autoScroll = false,
  renderSpan,
  onSpanClick,
}: ZipkinTraceChartProps<T>) => {
  return (
    <TraceChart
      spans={spans}
      className={className}
      height={height}
      showTimeline={showTimeline}
      showDuration={showDuration}
      showSidebar={showSidebar}
      showLegend={false}
      autoScroll={autoScroll}
      renderSpan={renderSpan}
      onSpanClick={onSpanClick}
    />
  );
};
